import { getAppConfig } from '../../config';
import { Userpilot } from 'userpilot';

let isInitialized = false;

export interface IUserPilotUserTraits {
    companyID: string;
    name: string;
    username: string;
}

/**
 * Initializes Userpilot using the appConfig.
 */
const init = () => {
    const userPilotToken = getAppConfig().userPilotToken;

    if (!userPilotToken) {
        return;
    }

    if (isInitialized) {
        return;
    }

    Userpilot.initialize(userPilotToken);

    isInitialized = true;
};

/**
 * Identify the user to userpilot
 * @param userId unique identifier for the user
 * @param traits additional user traits about the user
 */
export const identifyUserPilot = (userId: string, traits: IUserPilotUserTraits) => {
    init();
    if (isInitialized) {
        Userpilot.identify(userId, traits);
    }
};

/**
 * Remove the user from userpilot when user logs out
 */
export const removeUserPilot = () => {
    isInitialized = false;
    Userpilot.identify('', {
        companyID: '',
        name: '',
        username: '',
    });
};
